<template>
  <b-card title="Atendimento do pedido" class="atendimento-pedido mt-2 mb-2" :aria-busy="carregando ? 'true' : 'false'">
    <p v-if="carregando" role="status">Carregando atendimento...</p>
    <div v-else-if="erro" role="alert">
      <p>{{ erro }}</p>
      <b-button variant="outline-primary" size="sm" @click="carregar">Tentar novamente</b-button>
    </div>
    <template v-else-if="atendimento">
      <p class="mb-1"><strong>Pedido comercial:</strong> {{ atendimento.referenciaPrincipal || pedidoId }}</p>
      <p v-if="atendimento.situacaoAtual && !referenciaBo" class="mb-1">
        <strong>Situação atual:</strong>
        {{ atendimento.situacaoAtual.situacaoMac || atendimento.situacaoAtual.situacaoErp || 'Não informada' }}
      </p>
      <atendimento-resumo :atendimento="atendimento" :pedido-id="pedidoId" :mostrar-referencia="false" />
      <b-alert v-if="!atendimento.disponivel" show variant="warning" class="mt-1">
        Ainda não há informações de atendimento disponíveis para este pedido.
      </b-alert>
      <template v-else>
        <p v-if="!atendimento.etapas.length" role="status">Nenhuma etapa de atendimento informada.</p>
        <p v-if="referenciaBo && !etapaSelecionada" role="status">BO {{ referenciaBo }} não encontrada neste atendimento.</p>
        <details v-for="(etapa, index) in atendimento.etapas" :key="etapa.id || index"
          class="border rounded p-1 mb-1" :class="{ 'etapa-bo-selecionada': etapa === etapaSelecionada }"
          :open="etapa === etapaSelecionada">
          <summary>
            <strong>{{ etapa.tipo === 'INICIAL' ? 'Etapa inicial' : `BO${String(etapa.numeroBackorder).padStart(2, '0')}` }}</strong>
            — {{ etapa.referencia || 'Referência não informada' }}
          </summary>
          <div v-if="etapa.segmentos && etapa.segmentos.length">
            <div v-for="(segmento, segmentoIndex) in etapa.segmentos" :key="segmento.externalKey || segmentoIndex" class="border rounded p-1 mb-1">
              <atendimento-itens :itens="segmento.itens || []" />
            </div>
          </div>
          <atendimento-itens v-else :itens="etapa.itens || []" />
        </details>
      </template>
    </template>
  </b-card>
</template>

<script>
import { BCard, BAlert, BButton } from 'bootstrap-vue';
import carregarAtendimento from '@/services/atendimentoPedido.service';
import AtendimentoResumo from './AtendimentoResumo.vue';
import AtendimentoItens from './AtendimentoItens.vue';

export default {
  components: { BCard, BAlert, BButton, AtendimentoResumo, AtendimentoItens },
  props: { pedidoId: { type: [String, Number], required: true } },
  data() { return { atendimento: null, carregando: false, erro: '', requisicao: 0 }; },
  computed: {
    referenciaBo() {
      const bo = this.$route && this.$route.query && this.$route.query.bo;
      return typeof bo === 'string' ? bo : '';
    },
    etapaSelecionada() {
      return this.atendimento && this.atendimento.disponivel && this.referenciaBo
        ? (this.atendimento.etapas || []).find(etapa => etapa.referencia === this.referenciaBo) || null
        : null;
    },
  },
  watch: { pedidoId: { immediate: true, handler: 'carregar' } },
  beforeDestroy() { this.requisicao += 1; },
  methods: {
    async carregar() {
      const requisicao = ++this.requisicao;
      this.atendimento = null;
      this.erro = '';
      this.carregando = true;
      try {
        const atendimento = await carregarAtendimento(this.pedidoId);
        if (requisicao === this.requisicao) this.atendimento = atendimento;
      } catch (error) {
        if (requisicao === this.requisicao) {
          const status = error.response && error.response.status;
          this.erro = `Não foi possível carregar o atendimento${status ? ` (HTTP ${status})` : ''}. ${error.message || ''}`;
        }
      } finally {
        if (requisicao === this.requisicao) this.carregando = false;
      }
    },
  },
};
</script>

<style scoped>
summary { cursor: pointer; }
.atendimento-pedido { color: var(--sf-text-primary, #0f172a); }
.atendimento-pedido .text-muted { color: var(--sf-text-secondary, #334155) !important; }
.etapa-bo-selecionada {
  border-color: #7367f0 !important;
  background-color: var(--sf-surface-primary, #fff);
  background-image: linear-gradient(rgba(115, 103, 240, .08), rgba(115, 103, 240, .08));
  color: var(--sf-text-primary, #0f172a);
}
</style>